/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="rzn-grid rzn-grid--gap-small">
   {{#products}}
   <div data-product-id="{{empi}}" class="swym-wishlist-item rzn-grid__item--3 rzn-grid__item--small--4 rzn-grid__item--narrow--6">
     <button id="swym-remove-productBtn-{{epi}}" aria-label="{{deleteAriaLabel}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button swym-remove-productBtn">+</button>
     <a href="{{du}}" aria-label="{{dt}}" class="swym-is-anchor">
       <div class="swym-wishlist-image-wrapper">
         <img alt="" class="swym-wishlist-image" src="{{iu}}">
       </div>
       <div id="swym-product-title-{{epi}}" class="swym-title swym-title-1">
         {{dt}}
       </div>
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
         {{variantinfo}}
       </div>
       <div class="swym-product-price swym-text swym-text-1">
         <div class="swym-product-final-price swym-value">
           {{pr}}{{cu}}
         </div>
       </div>
     </a>
     <button id="swym-custom-add-toCartBtn" aria-describedby="swym-product-title-{{epi}}" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="btn btn--secondary swym-add-to-cart-btn swym-is-button swym-is-button">
       {{#isInCart}}` + added_to_cart_label + `{{/isInCart}}{{^isInCart}}` + add_to_cart_label + `{{/isInCart}}
     </button>
   </div>
   {{/products}}
</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	var target = e.target;
	if (isLanguageEn()) {
		e.target.innerHTML = "Adding..";
	} else {
		e.target.innerHTML = "Wird hinzugefügt..";
	}
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		if (isLanguageEn()) {
			e.target.innerHTML = "Added to Cart";
		} else {
			e.target.innerHTML = "Hinzugefügt";
		}
		e.target.setAttribute("data-state-cart", "swym-added");
		//console.log("Successfully added product to cart.", c);
	}, function(e) {
		if (isLanguageEn()) {
			target.innerHTML = "Sold out";
		} else {
			target.innerHTML = "Ausverkauft";
		}
		//console.log(e);
	});
}
/*
function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url").split("?")[0];
	e.target.innerHTML = "Adding..";
	let formData = {
		'items': [{
			'id': variantId,
			'quantity': 1
		}]
	};
	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(formData)
	}).then(response => {
		if (response.ok == true) {
			e.target.innerHTML = "Added to Cart";
			e.target.setAttribute("data-state-cart", "swym-added");
			console.log("Successfully added product to cart.",response);
			return response.json();
		} else {
			console.log('not okay', response);
		}
	}).catch((error) => {
		console.error('Error:', error);
	});
}
*/

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.cu = ' EUR';
			p.pr = p.pr.replace('.', ',').replace(',00', '');
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			p.deleteAriaLabel = delete_label + ': ' + p.dt + (p.variantinfo ? ', ' + p.variantinfo : '');
			if (product_ids_with_hidden_price.includes(p.empi)) {
				p.pr = '';
				p.cu = '';
			}
			return p;
		});

		var viewPortCheck = false;
		if (window.innerWidth > 850 && formattedWishlistedProducts.length > 4) {
			viewPortCheck = true;
		} else if (window.innerWidth <= 850 && window.innerWidth > 500 && formattedWishlistedProducts.length > 3) {
			viewPortCheck = true;
		} else if (window.innerWidth <= 500 && formattedWishlistedProducts.length > 2) {
			viewPortCheck = true;
		}

		if (formattedWishlistedProducts.length == 0 && document.querySelector('.customer__wishlist__no-favourites')) {
			document.querySelector('.customer__wishlist__no-favourites').style.display = 'block';
			if (document.getElementById('wishlist-login-notice')) {
				document.getElementById('wishlist-login-notice').style.display = 'none';
			}
		} else if (viewPortCheck == true && document.getElementById('show-all-wishlist')) {
			document.getElementById('show-all-wishlist').style.display = 'flex';
		}
		if (formattedWishlistedProducts.length > 0 && document.getElementById('wishlist-clear-all')) {
			document.getElementById('wishlist-clear-all').style.display = 'inline-block';
		}
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll(".swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

document.addEventListener('DOMContentLoaded', function() {
	var clearAll = document.getElementById('wishlist-clear-all');
	if (clearAll) {
		clearAll.addEventListener('click', function() {
			clearAll.style.display = 'none';
			document.querySelectorAll('.swym-remove-productBtn').forEach(function(btn) { btn.click(); });
			window.location.reload();
		});
	}
});